import * as React from "react";

function SvgPowerCharge(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={26} height={15.874} {...props}>
      <g
        data-name="Icon feather-battery-charging"
        fill="none"
        stroke="#039be5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          data-name="Path 43199"
          d="M5.323 14.483H3.162A2.172 2.172 0 011 12.301V3.574a2.172 2.172 0 012.162-2.182h3.447m9.522 0h2.162a2.172 2.172 0 012.162 2.182v8.727a2.172 2.172 0 01-2.162 2.182h-3.448"
        />
        <path data-name="Path 43200" d="M25 9.074V6.801" />
        <path data-name="Path 43201" d="M11.989 1.392L7.443 7.937h6.818l-4.546 6.545" />
      </g>
    </svg>
  );
}

export default SvgPowerCharge;
